
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M20.455 15.647l-1.106-1.846a4.245 4.245 0 01-.604-2.184V8.99c0-3.716-3.026-6.74-6.745-6.74-3.72 0-6.745 3.023-6.745 6.74v2.627c0 .769-.21 1.524-.604 2.184l-1.106 1.846a2.025 2.025 0 00-.026 2.063 2.028 2.028 0 001.785 1.041h3.98c-.008.084-.033.165-.033.25a2.752 2.752 0 002.75 2.75 2.752 2.752 0 002.75-2.75c0-.085-.025-.166-.033-.25h3.98c.749 0 1.417-.39 1.785-1.04a2.03 2.03 0 00-.028-2.064zm-7.206 3.354c0 .689-.561 1.25-1.25 1.25-.69 0-1.25-.561-1.25-1.25 0-.085.016-.168.033-.25h2.434c.017.082.033.165.033.25zm5.927-2.03a.54.54 0 01-.48.279H5.302a.542.542 0 01-.48-.28.539.539 0 01.007-.552l1.106-1.846a5.743 5.743 0 00.818-2.955V8.99a5.249 5.249 0 015.245-5.24 5.249 5.249 0 015.245 5.24v2.627c0 1.04.283 2.062.818 2.955l1.106 1.846c.15.248.056.469.009.553z"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/lk/img/Bell.svg